import { render, staticRenderFns } from "./FileLink.vue?vue&type=template&id=2958f6ea&scoped=true&"
import script from "./FileLink.vue?vue&type=script&lang=js&"
export * from "./FileLink.vue?vue&type=script&lang=js&"
import style0 from "./FileLink.vue?vue&type=style&index=0&id=2958f6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2958f6ea",
  null
  
)

export default component.exports